module.exports = __webpack_public_path__ + "img/img_010@2x.6b535645.png";